export default "__VITE_ASSET__pEwbfnjc__"